(function () {
    'use strict';
    /**
     * @memberof appback
     *@ngdoc service
     *@name DistribuidorService
     *@description
     *Ficha de distribuidor (backend\controllers\DistribuidorController)
     */

    angular
        .module('appback')
        .factory('DistribuidorService', DistribuidorService);

    DistribuidorService.$inject = ["$http", "$q"];

    function DistribuidorService($http, $q) {

        var distribuidor = {
            GetFicha: GetFicha,
        };

        function GetFicha(id) {
            return $http.get('/backend/distribuidor/getficha', {
                params: {
                    id: id
                }
            }).then(function (response) {
                if (!response.data || !response.data.success || !response.data.data) {
                    return $q.reject(response.data);
                }

                return response.data.data;
            });
        }

        return distribuidor;
    }
})();
